var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneWhiteSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#004080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_58651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.067 19.3718L22.4687 21.9659C22.3846 22.3327 22.0623 22.5892 21.6848 22.5892C15.192 22.5887 9.91113 17.3078 9.91113 10.8148C9.91113 10.4376 10.1677 10.1148 10.5344 10.0312L13.1286 9.43285C13.5064 9.3453 13.8924 9.5414 14.0494 9.89917L15.2466 12.6915C15.3865 13.0203 15.2921 13.4035 15.0155 13.6295L13.6299 14.742C14.5044 16.5234 15.9528 17.9718 17.7347 18.8468L18.8691 17.4623C19.0927 17.1848 19.4787 17.0888 19.8076 17.2313L22.5999 18.4282C22.9358 18.6049 23.1545 18.9961 23.067 19.3718Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_58651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1765,
    height: 13.1765,
    fill: "white",
    transform: "translate(9.91113 9.41211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhiteSvg);
export default __webpack_public_path__ + "static/media/PhoneWhiteSvg.07ec3e70183eb95fac4d60305c00e614.svg";
export { ForwardRef as ReactComponent };